// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Kh","centerLink":"Lh","productSection":"Mh","item":"Nh","ctaButton":"Oh"};